import headerBtn from './pages/page-2/components/header-btn.vue';
const moduleExampleRoutes = {
	path: 'module-example',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'page-1',
			component: () => import('./pages/page-1/index.vue'),
		},
		{
			path: 'page-2',
			component: () => import('./pages/page-2/index.vue'),
			meta: {
				headerExtraComponent: headerBtn,
			},
		},
		{
			path: 'table-example',
			component: () => import('./pages/table-example/index.vue'),
			meta: {
				title: 'تجربة الجدول',
			},
		},
		{
			path: 'input-docs',
			component: () => import('./pages/docs/input-docs.vue'),
			meta: {
				title: 'Input Docs',
			},
		},
		{
			path: 'text-area-docs',
			component: () => import('./pages/docs/text-area-docs.vue'),
			meta: {
				title: 'Text Area Docs',
			},
		},
		{
			path: 'button-docs',
			component: () => import('./pages/docs/button-docs.vue'),
			meta: {
				title: 'Button Docs',
			},
		},
		{
			path: 'forms-docs',
			component: () => import('./pages/docs/forms-docs.vue'),
			meta: {
				title: 'Forms Docs',
			},
		},
		{
			path: 'select-docs',
			component: () => import('./pages/docs/select-docs.vue'),
			meta: {
				title: 'Select Docs',
			},
		},
		{
			path: 'editor-docs',
			component: () => import('./pages/docs/editor-docs.vue'),
			meta: {
				title: 'Editor Docs',
			},
		},
		{
			path: 'skeleton-docs',
			component: () => import('./pages/docs/skeleton-docs.vue'),
			meta: {
				title: 'Skeleton Docs',
			},
		},
		{
			path: 'radio-docs',
			component: () => import('./pages/docs/radio-docs.vue'),
			meta: {
				title: 'Radio Docs',
			},
		},
		{
			path: 'file-upload-docs',
			component: () => import('./pages/docs/file-upload-docs.vue'),
			meta: {
				title: 'File Upload Docs',
			},
		},
		{
			path: 'paginated-scroll-area-docs',
			component: () => import('./pages/docs/paginated-scroll-area-docs.vue'),
			meta: {
				title: 'Paginated scroll Area Docs',
			},
		},
		{
			path: 'checkbox-docs',
			component: () => import('./pages/docs/checkbox-docs.vue'),
			meta: {
				title: 'Checkbox Docs',
			},
		},
		{
			path: 'date-input-docs',
			component: () => import('./pages/docs/date-input-docs'),
			meta: {
				title: 'Date Input Docs',
			},
		},
		{
			path: 'badge-docs',
			component: () => import('./pages/docs/badge-docs.vue'),
			meta: {
				title: 'Badge Docs',
			},
		},
		{
			path: 'checkbox-docs',
			component: () => import('./pages/docs/checkbox-docs.vue'),
			meta: {
				title: 'Checkbox Docs',
			},
		},
		{
			path: 'paginated-scroll-area-docs',
			component: () => import('./pages/docs/paginated-scroll-area-docs.vue'),
			meta: {
				title: 'Paginated scroll Area Docs',
			},
		},
		{
			path: 'toggle-docs',
			component: () => import('./pages/docs/toggle-docs.vue'),
			meta: {
				title: 'Toggle Docs',
			},
		},
		{
			path: 'notifications',
			component: () => import('./pages/docs/notifications-docs'),
			meta: {
				title: 'Notifications',
			},
		},
        {
			path: 'header-title-component',
			component: () => import('./pages/page-2/index.vue'),
			meta: {
				headerExtraComponent: headerBtn,
				headerTitleComponent: headerBtn,
			},
		},
        {
			path: 'timeline-docs',
			component: () => import('./pages/docs/timeline-docs.vue'),
			meta: {
				title: 'Timeline Docs',
			},
		},
        {
			path: 'image-docs',
			component: () => import('./pages/docs/image-docs.vue'),
			meta: {
				title: 'Image Docs',
			},
		},
        {
			path: 'icon-docs',
			component: () => import('./pages/docs/icon-docs.vue'),
			meta: {
				title: 'Icon Docs',
			},
		},
        {
			path: 'drag-drop-docs',
			component: () => import('./pages/docs/drag-drop.vue'),
			meta: {
				title: 'Icon Docs',
			},
		},
        {
			path: 'print-docs',
			component: () => import('./pages/docs/print-docs'),
			meta: {
				title: 'Print Docs',
			},
		},
	],
};

export { moduleExampleRoutes };
